import styled, { css } from 'styled-components';
import { calcOpacity } from 'utils/calcOpacity';
import { HEADER_LATERAL_PADDING } from '../constants';

export const CloseButtonWrapper = styled.div`
  ${({ theme }) => css`
    position: sticky;
    float: right;
    top: ${theme.spacing.km6};
    z-index: 23;
    right: ${HEADER_LATERAL_PADDING}px;
  `}
`;

export const ContactListButtonWrapper = styled.div<{ scrolledValue: number }>`
  ${({ theme, scrolledValue }) => css`
    position: sticky;
    float: left;
    top: ${theme.spacing.km6};
    left: ${HEADER_LATERAL_PADDING}px;
    z-index: 23;
    display: ${scrolledValue <= 118 ? 'block' : 'none'};
    opacity: ${calcOpacity(118, scrolledValue, 74)};
  `}
`;
